'use client';

/**
 * Button that opens the Ask Lab palette. A progressive enhancement: without
 * JavaScript it renders but does nothing — every route it can reach is also
 * reachable through plain links.
 */

import type { ReactNode } from 'react';
import { useWorld } from '../../lab/store';
import { useLang } from '../../i18n/client';
import { getDict } from '../../i18n/dictionary';

interface OpenAskProps {
  label?: string;
  children?: ReactNode;
  /** Extra class(es) appended to the base `.btn` — lets a caller style the
   *  button as a distinct primary action instead of the nav's chorded one. */
  className?: string;
}

export default function OpenAsk({ label, children, className }: OpenAskProps) {
  const dict = getDict(useLang());
  return (
    <button
      type="button"
      className={className ? `btn ${className}` : 'btn'}
      onClick={() => useWorld.getState().setPaletteOpen(true)}
    >
      {children ?? label ?? dict.ask.askThingLabel}
    </button>
  );
}
